import { createSlice } from "@reduxjs/toolkit";

// apiPoints and graphtype used to live here too. They were CryptoCompare's URL
// parameters - a candle count and a candle size - and nothing reads them now
// that netlify/functions/chart.mjs owns the upstream query. timeRange is the
// only thing the function needs.
const initialState = {
  timeRange: "1D",
  timeFrame: "Today",
};

//dont know what to name these yet
const timeCustomSlice = createSlice({
  name: "chartTimeCustomization",
  initialState,
  reducers: {
    //object reducers where everything that touches state and actions
    //and reducers that modify it
    dayChartState: (state) => {
      state.timeRange = "1D";
      state.timeFrame = "Today";
    },

    weekChartState: (state) => {
      state.timeRange = "1W";
      state.timeFrame = "Past Week";
    },

    monthChartState: (state) => {
      state.timeRange = "1M";
      state.timeFrame = "Past Month";
    },

    // There is no 5Y any more. CoinGecko's free tier refuses anything older
    // than 365 days outright, and running a second provider for one button was
    // not worth it.
    yearChartState: (state) => {
      state.timeRange = "1Y";
      state.timeFrame = "Past Year";
    },

    // incrementByAmount: (state, action) => {
    //2nd param- action , which u can give it a payload,
    //payload allows u to pass any value and icrement it
    //by that
    //   state.count += action.payload;
    // },
  },
});

//Action creators are generated for each case reducer function.
export const {
  dayChartState,
  weekChartState,
  monthChartState,
  yearChartState,
} = timeCustomSlice.actions;
export default timeCustomSlice.reducer;
